import React from "react";
import { Typography, Box } from "@mui/material";

const AboutUsSection = () => {
  return (
    <Box
      id="aboutUs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        gap: { xs: "20px", md: "24px" },
        px: { xs: 2.5, md: 0 },
        paddingBlock: { xs: "2.5rem", md: "3rem" },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "Helvetica",
          fontSize: { xs: "1.875rem", sm: "2.125rem", md: "2.25rem" },
          fontWeight: 700,
        }}
      >
        Stress-Free Movement of Goods is now Possible!​
        <br />
        You are just a click away from it!
      </Typography>

      <Typography
        variant="body1"
        maxWidth="lg"
        sx={{
          color: "#4E4E4E",
          textAlign: "center",
          fontFamily: "Helvetica",
          fontSize: { xs: "1.0625rem", sm: "1.25rem", md: "1.5rem" },
          fontWeight: 400,
          px: { xs: 1, sm: 3, md: 0 },
        }}
      >
        Most trusted in the logistics sector, LoadEazy delivers technologically
        advanced and out of the box transport services to its customers. We
        offer industry specific transport solutions across India. Our current
        focus being the Iron & Steel Industry.
      </Typography>
    </Box>
  );
};

export default AboutUsSection;
